import { useRef } from 'react';
import { dbPost } from '../../apis/commonApi';

const InputVideo = ({
  modalService,
  anlsAplyId,
  taskId,
  workId,
  vdoId,
  vldScsYn,
  vldErrId,
  aiaScsStts,
  aiaErrId,
  callBackFunc,
}) => {
  const fileInputRef = useRef();

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const checkVideoFile = file => {
    return new Promise((resolve, reject) => {
      // 1. 파일 확장자 체크
      const fileName = file.name.toLowerCase();
      const validExtensions = ['.mp4', '.mov', '.avi', '.mkv'];
      if (!validExtensions.some(ext => fileName.endsWith(ext))) {
        reject(
          '지원하지 않는 파일 형식입니다. (지원 형식: mp4, mov, avi, mkv)'
        );
        return;
      }

      // 2. 파일 크기 검증 (10MB ~ 250MB)
      const maxSize = 250 * 1024 * 1024;
      const minSize = 10 * 1024 * 1024;

      if (file.size < minSize) {
        reject('파일 크기는 10MB 이상이어야 합니다.');
      }
      if (file.size > maxSize) {
        reject('파일 크기는 250MB를 초과할 수 없습니다.');
        return;
      }

      // 3. 비디오 메타데이터 검증
      const video = document.createElement('video');
      video.preload = 'metadata';
      const videoUrl = URL.createObjectURL(file);

      const timeoutId = setTimeout(() => {
        cleanup();
        reject('영상 파일을 읽을 수 없습니다. 파일이 손상되었을 수 있습니다.');
      }, 5000);

      const cleanup = () => {
        clearTimeout(timeoutId);
        URL.revokeObjectURL(videoUrl);
        video.remove();
      };

      video.onerror = () => {
        cleanup();
        reject('손상되었거나 재생할 수 없는 영상 파일입니다.');
      };

      video.onloadedmetadata = () => {
        if (!video.videoWidth || !video.videoHeight || !video.duration) {
          cleanup();
          reject('영상 파일이 손상되었거나 잘못된 형식입니다.');
          return;
        }

        const quality = {
          width: video.videoWidth,
          height: video.videoHeight,
          duration: video.duration,
          size: file.size,
        };

        // 4. 해상도 검증
        const isLandscape = quality.width >= quality.height;

        if (isLandscape) {
          if (quality.width < 1280 || quality.height < 720) {
            cleanup();
            reject('동영상 해상도가 너무 낮습니다. (최소 1280x720 필요)');
            return;
          }
          if (quality.width > 1920 || quality.height > 1080) {
            cleanup();
            reject('동영상 해상도가 너무 높습니다. (최대 1920x1080)');
            return;
          }
        } else {
          if (quality.width < 720 || quality.height < 1080) {
            cleanup();
            reject('동영상 해상도가 너무 낮습니다. (최소 720x1080 필요)');
            return;
          }
          if (quality.width > 1080 || quality.height > 1920) {
            cleanup();
            reject('동영상 해상도가 너무 높습니다. (최대 1080x1920)');
            return;
          }
        }

        // 5. 검증 통과
        cleanup();
        resolve(quality);
      };

      video.src = videoUrl;
    });
  };

  const handleFileChange = async event => {
    if (callBackFunc instanceof Function) {
      callBackFunc(true);
    }

    const file = event.target.files[0];

    try {
      // 파일 검증 추가
      await checkVideoFile(file);

      // 업로드 로직
      const url = '/aia/analysis/video/upload.do';
      const formData = new FormData();
      formData.append('file', file);
      formData.append('anlsAplyId', anlsAplyId);
      formData.append('taskId', taskId);
      formData.append('workId', workId);
      formData.append('vdoId', vdoId);

      const response = await dbPost(url, formData);

      if (response instanceof Error) {
        throw new Error('업로드중 에러가 발생했습니다.');
      }

      if (callBackFunc instanceof Function) {
        callBackFunc(false);
      }
    } catch (error) {
      modalService.errorAlert(error, () => {});
    }
  };

  return (
    <>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept="video/*"
        multiple={false}
        style={{ display: 'none' }}
        id="input-files"
        aria-labelledby="input-files"
      />
      {vldScsYn === null ||
      (vldScsYn === 'Y' && vldErrId !== null && vldErrId?.length > 0) ||
      (vldScsYn === 'Y' && aiaErrId !== null && aiaErrId?.length > 0) ? (
        <button
          type="button"
          className="btn tertiary md ico-before ico-upload"
          onClick={() => {
            handleUploadClick();
          }}
        >
          영상 업로드
        </button>
      ) : (
        <button
          type="button"
          className="btn tertiary md ico-before ico-upload"
          disabled
        >
          영상 업로드
        </button>
      )}
    </>
  );
};

export default InputVideo;
